// Constants needed before optional measurement code loads. Keep the landing
// parameter parser in measurementPolicy so it stays in the lazy runtime.
export const MEASUREMENT_POLICY_VERSION = 'consumer-measurement-2026-11-02';
export const GOOGLE_MEASUREMENT_POLICY_VERSION = 'consumer-google-measurement-2026-11-02';
export const MEASUREMENT_NOTICE_VERSION = 'consumer-measurement-2026-11-02-v2';
export const MEASUREMENT_NOTICE = 'We use analytics and advertising measurement to understand visits and which ads lead to contact requests.';

export interface MeasurementBootstrap {
  policyVersion: typeof MEASUREMENT_POLICY_VERSION;
  analyticsDefault: boolean;
  captureEligible: boolean;
  gpc: boolean;
  denied: boolean | null;
  revision: number | null;
  googlePolicyVersion: typeof GOOGLE_MEASUREMENT_POLICY_VERSION;
  googleAllowed: boolean | null;
  googleRevision: number | null;
  csrf: string;
  revoke: { context: string; capability: string };
}
